<template>
  <div class="Header">
    <div class="main-content">
      <div class="row blueHeaderBG vertical-align position-fixed container-fluid">
        <div class="col-xs-3 col-sm-2 col-md-2 col-lg-2 padding-left-0px padding-right-0px">
          <img src="../../assets/images/ipl-logo-orange.svg" class="img-responsive icon-width-height align-center" alt="logo"  @click="performOperation($event, 'home')" v-bind:class="{'cursor-pointer' : !isGroupAdmin}">
        </div>
        <div class="col-xs-3 col-sm-6 col-md-7 col-lg-7 white-text-color text-size-20px text-align-left padding-left-4point3Perc">
          Welcome, {{getUserFullName}}!
        </div>
        <!-- <div class="col-md-1 col-lg-1">
          <span class="label label-warning">beta feature</span>
        </div>
        <div class="col-md-1 col-lg-1 padding-left-right-0px">
          <img :src="getUserProfileImg()" alt="usericon2" class=" border-radius" width="50px" height="50px" @error="assignDefaultImage($event)" id="userProfile">
        </div> -->  
        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 padding-left-right-0px text-align-right vertical-align">
          <div class="col-xs-2 col-sm-4 col-md-5 col-lg-5"></div>
          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-3" :class="{'label label-warning': showBetaVersion}">{{showBetaVersion ? 'beta feature' : ''}}</div>
          <div class="col-xs-4 col-sm-3 col-md-3 col-lg-3">
            <img :src="getUserProfileImg()" alt="usericon2" class=" border-radius" width="50px" height="50px" @error="assignDefaultImage($event)" id="userProfile">
          </div>
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-1Perc">
            <div class="btn-group">  
              <span class="glyphicon glyphicon-option-vertical dropdown-toggle cursor-pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span>
              <div class="dropdown-menu dropdown-menu-right margin-top-5px">
                <button class="dropdown-item width-100Perc text-align-text bottom-border background-color-white" @click="performOperation($event, 'home')" v-if="!isGroupAdmin">Home</button>
                <button class="dropdown-item width-100Perc text-align-text bottom-border background-color-white" @click="performOperation($event, 'edit_profile')">Edit Profile</button>
                <button class="dropdown-item width-100Perc text-align-text background-color-white" @click="performOperation($event, 'logout')">Logout</button>
              </div>
            </div>  
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>
<script>
import server from '@/utils/server'
import defaultUserIcon from '../../assets/images/usericon2.svg'
import { constants } from '@/utils/constants'
export default {
  props: ['showBetaVersion'],
  data: function () {
    return {}
  },
  components: {},
  methods: {
    performOperation: function (event, selectedOperation) {
      switch (selectedOperation) {
        case 'home':
          if (!this.isGroupAdmin) {
            localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Content)
            localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.Courses)
            this.$store.state.isComingFromLogin = false
            this.$router.push('/courses')
          }
          break
        case 'edit_profile':
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$store.state.isComingFromLogin = false
          this.$router.push('/profile')
          break
        case 'logout':
          var cookies = this.$cookies
          cookies.remove(constants.LOGIN_COOKIE_KEY)
          cookies.remove(constants.LOGIN_USER_COOKIE)
          this.$store.state.isUserProfileLoaded = false
          localStorage.removeItem(constants.LOGIN_USER_COOKIE)
          localStorage.setItem('selectedMenu', 0)
          localStorage.setItem('selectedSubMenu', 0)
          this.resetSelectedGroupCourseAndCohortObj()
          this.resetStateValues()
          break
      }
    },
    assignDefaultImage: function (event) {
      document.getElementById('userProfile').src = defaultUserIcon
    },
    getUserProfileImg () {
      var userObj = this.$store.state.curr_user
      this.imgUrl = server.baseURL() + '/api/UserProfile/Picture?userId=' + userObj.UserId
      return this.imgUrl
    },
    resetSelectedGroupCourseAndCohortObj: function () {
      this.$store.state.selectedGroupCourseObj = {}
      this.$store.state.selectedCohortObj = {}
    },
    resetStateValues: function () {
      this.$store.commit('resetState')
    }
  },
  computed: {
    getUserFullName: {
      get: function () {
        var userObj = this.$store.state.curr_user
        return userObj.FirstName
      }
    },
    isGroupAdmin: {
      get: function () {
        if (parseInt(this.$store.state.curr_user.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        }
        return false
      }
    }
  },
  name: 'Header'
}
</script>

<style scoped>
.Header {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
.sendGridList{
  min-height: 57vh;
}
.blueHeaderBG {
  background-color: #27345b;
}
.icon-width-height {
  height: 70px;
  width:92%;
}
.white-text-color {
  color: #ffffff;
}
.text-align-left {
  text-align: left;
}
.text-size-20px {
  font-size: 20px !important;
}
.glyphicon {
    font-size: 25px;
    color: white;
}
.cursor-pointer {
  cursor: pointer;
}
.width-100Perc {
  width: 100% !important;
}
.text-align-text {
  text-align: right !important;
}
button {
  border: 0px solid transparent !important;
  padding-top: 7px !important; 
  padding-bottom: 7px !important;
}
.margin-top-5px {
  margin-top: 10px !important;
}
.border-radius {
  border-radius: 25px; 
}
.padding-left-right-0px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.margin-left-right-5px {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.background-color-grey {
  background-color: #DCDCDC;
}
.cursor-default {
  cursor: default;
}
.opacity-point-5 {
  opacity: 0.5;
}
.padding-left-4point3Perc{
  padding-left:4.3%;
}
.position-fixed{
  /* overflow: hidden; */
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.background-color-white{
  background-color:#ffffff;
}
.width-3Point5Perc{
  width:3.5%;
}
.text-align-right{
  text-align:right;
}
.padding-left0px {
  padding-left: 0px !important;
}

@media (max-width: 768px) {
  .text-size-20px {
    font-size: 14px !important;
  }
}
.padding-left-0px{
  padding-left:0px;
}
.padding-right-0px{
  padding-right:0px;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.padding-left-1Perc{
  padding-left:1%;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard_v2/Header.vue